import { flexCenterSx } from '../../styles/Global.style';

export const feedSx = { ...flexCenterSx, flexDirection: 'column' };
